










 

 















const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgDetails_organization",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrgBillingDangerZone_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditableOrgName_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrgFeatureFlags_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrgFeatures_organization"
    },
    {
      "alias": "orgId",
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isBillingLeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "picture",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingTier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node ).hash = "887f48a38ac549200595ba6481c02fc5";

export default node;
